import { useEffect, useState } from 'react';
import axios from 'axios';
import _pick from 'lodash/pick';
import { log } from '../../utilities/logger';
import parseActivationUrl from './parseActivationUrl';
import { useLoginApi } from '../../apiHooks/apiHooks';
export const validateActivationStatus = (BaseComponent) => {
  const WrappedComponent = (props) => {
    const [dataFromURL, setDataFromURL] = useState({});
    const { fetchOrgAndOrgAlias } = useLoginApi();

    useEffect(() => {
      const handleAsyncEffect = async () => {
        // Check if user is already activated,
        // if true redirect to login else take to activation
        try {
          const updater = await parseActivationUrl();
          const orgData = await fetchOrgAndOrgAlias(updater.orgId, updater.env);
          updater.orgIdAlias = orgData.orgIdAlias;
          updater.orgId = orgData.orgId;
          const response = await axios({
            url: `${updater.lab}/user/getActivationStatus`,
            headers: _pick(updater, ['orgId', 'passwordToken', 'loginId']),
            'Content-Type': 'application/json',
            method: 'POST',
            data: {}
          });

          if (response?.data['userActivationStatus']) {
            window.location.href =
              `${window.location.origin}?` +
              // eslint-disable-next-line max-len
              `org=${orgData.orgIdAlias}&env=${updater.env}&lab=${updater.lab}&` +
              `user=${encodeURIComponent(updater.loginId)}`;
          } else {
            setDataFromURL(updater);
          }
        } catch (err) {
          log(err);
        }
      };

      handleAsyncEffect();
    }, []);
    return <BaseComponent {...props} dataFromURL={dataFromURL} />;
  };
  WrappedComponent.displayName = `withActivationStatus(${
    BaseComponent.displayName || BaseComponent.name || 'Component'
  })`;
  return WrappedComponent;
};
